(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["montgomery-fit-assistant"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFitAssistant = (root) => {
      if (!root || root.dataset.mfitInitialized === 'true') return;
      root.dataset.mfitInitialized = 'true';

      const steps = [...root.querySelectorAll('[data-mfit-step]')];
      const tabs = [...root.querySelectorAll('[data-mfit-tab]')];
      const nextButtons = [...root.querySelectorAll('[data-mfit-next]')];
      const backButtons = [...root.querySelectorAll('[data-mfit-back]')];
      const unitButtons = [...root.querySelectorAll('[data-mfit-unit]')];
      const measurementInput = root.querySelector('[data-mfit-measurement]');
      const unitLabel = root.querySelector('[data-mfit-unit-label]');
      const error = root.querySelector('[data-mfit-error]');
      const resultTrigger = root.querySelector('[data-mfit-result-trigger]');
      const resultPanel = root.querySelector('[data-mfit-result]');
      const resultSize = root.querySelector('[data-mfit-result-size]');
      const resultSummary = root.querySelector('[data-mfit-result-summary]');
      const resultNote = root.querySelector('[data-mfit-result-note]');
      const resultSelect = root.querySelector('[data-mfit-select-size]');
      const restart = root.querySelector('[data-mfit-restart]');
      const chart = root.querySelector('[data-mfit-chart]');
      const chartOpen = root.querySelector('[data-mfit-chart-open]');
      const sizeRows = [...root.querySelectorAll('[data-mfit-size-row]')]
        .map((row) => ({
          row,
          size: row.dataset.size,
          cm: Number.parseFloat(row.dataset.cm)
        }))
        .filter((item) => item.size && Number.isFinite(item.cm))
        .sort((a, b) => a.cm - b.cm);

      let currentStep = 0;
      let currentUnit = 'cm';
      let recommendedSize = '';

      const showStep = (index) => {
        currentStep = Math.max(0, Math.min(index, steps.length - 1));
        resultPanel.hidden = true;
        steps.forEach((step, stepIndex) => {
          const active = stepIndex === currentStep;
          step.hidden = !active;
          step.classList.toggle('is-active', active);
        });
        tabs.forEach((tab, tabIndex) => {
          tab.classList.toggle('is-active', tabIndex === currentStep);
          tab.classList.toggle('is-complete', tabIndex < currentStep);
          if (tabIndex === currentStep) {
            tab.setAttribute('aria-current', 'step');
          } else {
            tab.removeAttribute('aria-current');
          }
        });
      };

      const measurementInCm = () => {
        const value = Number.parseFloat(measurementInput.value);
        if (!Number.isFinite(value)) return null;
        return currentUnit === 'in' ? value * 2.54 : value;
      };

      const validateMeasurement = () => {
        const cm = measurementInCm();
        if (!cm || cm <= 0) {
          error.textContent = 'Please enter your heel-to-toe measurement.';
          measurementInput.focus();
          return false;
        }
        error.textContent = '';
        return true;
      };

      const selectedRadio = (selector) => root.querySelector(`${selector} input:checked`);

      const calculateSize = () => {
        const cm = measurementInCm();
        if (!cm || !sizeRows.length) return null;

        const first = sizeRows[0];
        const last = sizeRows[sizeRows.length - 1];
        if (cm < first.cm - 0.6 || cm > last.cm) return null;

        let index = sizeRows.findIndex((item) => item.cm >= cm);
        if (index < 0) index = sizeRows.length - 1;

        if (root.dataset.applyAdjustments === 'true') {
          const socks = selectedRadio('[data-mfit-socks]');
          const fit = selectedRadio('[data-mfit-fit]');
          if (socks?.value === 'thick') index += 1;
          if (fit?.value === 'roomy') index += 1;
          index = Math.min(index, sizeRows.length - 1);
        }

        return sizeRows[index];
      };

      const showResult = () => {
        if (!validateMeasurement()) {
          showStep(0);
          return;
        }

        const recommendation = calculateSize();
        const socks = selectedRadio('[data-mfit-socks]');
        const fit = selectedRadio('[data-mfit-fit]');
        steps.forEach((step) => {
          step.hidden = true;
        });
        tabs.forEach((tab) => {
          tab.classList.remove('is-active');
          tab.classList.add('is-complete');
          tab.removeAttribute('aria-current');
        });
        resultPanel.hidden = false;

        sizeRows.forEach((item) => item.row.classList.remove('is-recommended'));
        if (recommendation) {
          recommendedSize = recommendation.size;
          resultSize.textContent = recommendedSize;
          recommendation.row.classList.add('is-recommended');
          resultSummary.textContent = `${measurementInput.value} ${currentUnit === 'cm' ? 'cm' : 'in'} · ${socks?.dataset.label || ''} · ${fit?.dataset.label || ''}`;
          resultNote.hidden = false;
          resultSelect.disabled = false;
        } else {
          recommendedSize = '';
          resultSize.textContent = 'CHECK CHART';
          resultSummary.textContent = 'Your measurement is outside the configured recommendation range.';
          resultNote.hidden = false;
          resultSelect.disabled = true;
        }
      };

      const selectProductSize = () => {
        if (!recommendedSize) return;
        let changed = false;
        const normalizedSize = recommendedSize.trim().toLowerCase();

        document.querySelectorAll('select[name^="options"]').forEach((select) => {
          const option = [...select.options].find((item) => item.value.trim().toLowerCase() === normalizedSize);
          if (option) {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            changed = true;
          }
        });

        document.querySelectorAll('input[type="radio"][name^="options"]').forEach((radio) => {
          if (radio.value.trim().toLowerCase() === normalizedSize) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            changed = true;
          }
        });

        const configuredTarget = root.dataset.scrollTarget;
        const target = configuredTarget ? document.querySelector(configuredTarget) : null;
        const productArea =
          target ||
          document.querySelector('[id^="MainProduct"]') ||
          document.querySelector('product-info') ||
          document.querySelector('.product') ||
          document.querySelector('form[action*="/cart/add"]');

        if (productArea) {
          productArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        if (!changed && chart) {
          chart.open = true;
        }
      };

      nextButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (currentStep === 0 && !validateMeasurement()) return;
          showStep(currentStep + 1);
        });
      });

      backButtons.forEach((button) => {
        button.addEventListener('click', () => showStep(currentStep - 1));
      });

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = Number.parseInt(tab.dataset.mfitTab, 10);
          if (index > 0 && !validateMeasurement()) return;
          showStep(index);
        });
      });

      unitButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const nextUnit = button.dataset.mfitUnit;
          if (nextUnit === currentUnit) return;
          const currentValue = Number.parseFloat(measurementInput.value);
          if (Number.isFinite(currentValue)) {
            measurementInput.value =
              nextUnit === 'in'
                ? (currentValue / 2.54).toFixed(1)
                : (currentValue * 2.54).toFixed(1);
          }
          currentUnit = nextUnit;
          unitLabel.textContent = nextUnit === 'cm' ? 'CM' : 'IN';
          unitButtons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          error.textContent = '';
        });
      });

      resultTrigger?.addEventListener('click', showResult);
      resultSelect?.addEventListener('click', selectProductSize);
      chartOpen?.addEventListener('click', () => {
        chart.open = true;
        chart.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      restart?.addEventListener('click', () => showStep(0));
      measurementInput?.addEventListener('input', () => {
        error.textContent = '';
      });

      showStep(0);
    };

    const initAllFitAssistants = (scope = document) => {
      scope.querySelectorAll('[data-mfit-root]').forEach(initFitAssistant);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllFitAssistants());
    } else {
      initAllFitAssistants();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllFitAssistants(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montgomery-help-center"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('montgomery-help-center')) {
    class MontgomeryHelpCenter extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.searchInput = this.querySelector('[data-mhc-search]');
        this.clearButton = this.querySelector('[data-mhc-clear]');
        this.noResults = this.querySelector('[data-mhc-no-results]');
        this.items = Array.from(this.querySelectorAll('[data-mhc-item]'));
        this.groups = Array.from(this.querySelectorAll('[data-mhc-group]'));

        if (this.searchInput) {
          this.searchInput.addEventListener('input', () => this.filter(this.searchInput.value));
          this.searchInput.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') this.clear();
          });
        }

        if (this.clearButton) {
          this.clearButton.addEventListener('click', () => this.clear());
        }

        if (this.dataset.singleOpen === 'true') {
          this.querySelectorAll('.mhc__faq').forEach((details) => {
            details.addEventListener('toggle', () => {
              if (!details.open) return;
              this.querySelectorAll('.mhc__faq[open]').forEach((openDetails) => {
                if (openDetails !== details) openDetails.removeAttribute('open');
              });
            });
          });
        }
      }

      normalize(value) {
        return String(value || '')
          .toLocaleLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim();
      }

      filter(value) {
        const query = this.normalize(value);
        let totalMatches = 0;

        this.items.forEach((item) => {
          const haystack = this.normalize(item.dataset.searchText);
          const matches = query === '' || haystack.includes(query);
          item.hidden = !matches;
          if (matches) totalMatches += 1;
        });

        this.groups.forEach((group) => {
          const visibleItems = group.querySelectorAll('[data-mhc-item]:not([hidden])').length;
          group.hidden = query !== '' && visibleItems === 0;
        });

        if (this.clearButton) this.clearButton.hidden = query === '';
        if (this.noResults) this.noResults.hidden = query === '' || totalMatches > 0;
      }

      clear() {
        if (!this.searchInput) return;
        this.searchInput.value = '';
        this.filter('');
        this.searchInput.focus();
      }
    }

    customElements.define('montgomery-help-center', MontgomeryHelpCenter);
  }

  } catch(e) { console.error(e); }
})();
})();
